module.exports = __webpack_public_path__ + "img/76143.c2809e5e.svg";